import { INVENTORY_IMAGES_URL } from '@constants';

export interface InventoryImage {
  imageLocation: string;
  remoteName: string;
}

export function buildInventoryImageUrl(
  image?: InventoryImage | null
): string | null {
  if (!image || !image.imageLocation || !image.remoteName) return null;
  return `${INVENTORY_IMAGES_URL}/${image.imageLocation}/small/${image.remoteName}`;
}

export function productPlaceholderImage(darkMode?: boolean): string {
  return `/images/product-placeholder-${darkMode ? 'dark' : 'light'}.svg`;
}
